import { useMemo } from 'react';
import { useGetAccountsQuery } from '../../redux/api/fymAPI';
import { useUserToken } from '../../redux/slices/appInfo/hooks';
import { defaultWorkspaceName } from './defaultWorkspaceName';
import { withoutDemoAccounts } from '../accountSelector/demoAccounts';

/**
 * The default name of the active workspace (design: workspaces d2), from its artists (the
 * accounts list) and the owner's email. Null while the artists load.
 */
export function useDefaultWorkspaceName(ownerEmail: string | null): string | null {
  const userToken = useUserToken();
  const { accounts } = useGetAccountsQuery(undefined, {
    skip: !userToken,
    selectFromResult: ({ data }) => ({ accounts: data?.accounts }),
  });
  return useMemo(
    // The demo artist (LaziiBee) never names a workspace.
    () =>
      accounts === undefined || ownerEmail === null
        ? null
        : defaultWorkspaceName(withoutDemoAccounts(accounts), ownerEmail),
    [accounts, ownerEmail]
  );
}
